(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("window"), require("ReactDOM"), require("classNames"), require("Tether"), require("React.addons.CSSTransitionGroup"));
	else if(typeof define === 'function' && define.amd)
		define(["React", "window", "ReactDOM", "classNames", "Tether", "React.addons.CSSTransitionGroup"], factory);
	else if(typeof exports === 'object')
		exports["Core"] = factory(require("React"), require("window"), require("ReactDOM"), require("classNames"), require("Tether"), require("React.addons.CSSTransitionGroup"));
	else
		root["Blueprint"] = root["Blueprint"] || {}, root["Blueprint"]["Core"] = factory(root["React"], root["window"], root["ReactDOM"], root["classNames"], root["Tether"], root["React.addons.CSSTransitionGroup"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_7__, __WEBPACK_EXTERNAL_MODULE_21__, __WEBPACK_EXTERNAL_MODULE_23__, __WEBPACK_EXTERNAL_MODULE_25__, __WEBPACK_EXTERNAL_MODULE_30__, __WEBPACK_EXTERNAL_MODULE_32__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition